import { StringUtils } from 'src/common/utils/stringUtils';
import { EducationLevel } from 'src/modules/Opportunity/interface';

import { SearchJobsQueryData } from '../../../graphqlUtils';
import { SEOSlugQuery } from '../../../types';

export const getSlugQueryForInternalSearchQueryPage = (
  jobSearchQuery?: SearchJobsQueryData,
  locationName?: string,
  locationId?: string
): SEOSlugQuery => {
  const companyIds = StringUtils.convertQueryToArrayString(
    jobSearchQuery?.CompanyId
  );
  return {
    country: jobSearchQuery?.CountryCode,
    type: jobSearchQuery?.type ?? [],
    workArrangementOptions: jobSearchQuery?.workArrangementOptions ?? [],
    educationLevel: (jobSearchQuery?.educationLevels as EducationLevel[]) ?? [],
    yearsOfExperiences: jobSearchQuery?.yearsOfExperienceFilter,
    sortBy: jobSearchQuery?.sortBy,
    locationIds: jobSearchQuery?.LocationIds,
    ...(companyIds && {
      companyIds,
    }),
    ...(jobSearchQuery?.SearchTerm && {
      Keyword: jobSearchQuery?.SearchTerm,
    }),
    ...(locationName && {
      locationName: locationName,
    }),
    ...(locationId && {
      locationId: locationId,
    }),
  };
};
